import React, { useEffect, useState } from 'react';
import { useT } from '../context/I18nContext';
import { useSite } from '../context/SiteContext';
import { ShieldCheck, X } from 'lucide-react';

const STORAGE_KEY = 'wss_age_verified';

const AgeGate = () => {
  const { t } = useT();
  const { site } = useSite();
  const brand = site?.brand || {};
  const enabled = brand.show_age_gate !== false; // default on
  const minAge = brand.age_gate_min || 18;

  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (!enabled) return;
    const v = typeof window !== 'undefined' ? localStorage.getItem(STORAGE_KEY) : '1';
    if (!v) setOpen(true);
  }, [enabled]);

  const accept = () => { localStorage.setItem(STORAGE_KEY, '1'); setOpen(false); };
  const decline = () => { window.location.href = 'https://www.google.com'; };

  if (!open) return null;
  return (
    <div
      role="dialog"
      aria-modal="true"
      aria-labelledby="agegate-title"
      className="fixed inset-0 z-[100] flex items-center justify-center p-4 bg-black/85 backdrop-blur-sm"
      data-testid="age-gate-modal"
    >
      <div className="relative w-full max-w-md bg-zinc-950 border-2 border-[#d4af37] rounded-lg p-8 text-center shadow-[0_0_60px_rgba(212,175,55,0.35)]">
        <ShieldCheck className="h-12 w-12 mx-auto text-[#d4af37] mb-4" />
        <p className="text-[#d4af37] tracking-[0.3em] text-[10px] uppercase mb-2">{t('agegate.eyebrow')}</p>
        <h2 id="agegate-title" className="serif-italic gold-gradient-text text-4xl mb-3">
          {t('agegate.title').replace('{age}', minAge)}
        </h2>
        <p className="text-zinc-300 text-sm leading-relaxed mb-6">
          {t('agegate.body').replace('{age}', minAge)}
        </p>
        <div className="flex flex-col gap-2">
          <button
            onClick={accept}
            data-testid="age-gate-yes"
            className="btn-gold w-full h-11 rounded tracking-wider uppercase text-sm"
          >
            {t('agegate.yes').replace('{age}', minAge)}
          </button>
          <button
            onClick={decline}
            data-testid="age-gate-no"
            className="text-zinc-400 hover:text-rose-400 h-10 text-sm tracking-wider uppercase transition-colors"
          >
            <X className="h-3.5 w-3.5 inline mr-1" /> {t('agegate.no')}
          </button>
        </div>
        <p className="text-zinc-600 text-[10px] mt-5">{t('agegate.footer')}</p>
      </div>
    </div>
  );
};

export default AgeGate;
